export default {
    methods: {
        debounce(func, delay = 250) {
            let timeout;

            return function(...args) {
                const context = this;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), delay);
            };
        }
    }
};
